import {ReactComponent as ProfileLogo} from '../assets/icons/profile.svg'
import {ReactComponent as FullScreenIcon} from '../assets/icons/fullscreen.svg'
import {ReactComponent as LayoutSvg} from '../assets/icons/layout.svg'
import {ReactComponent as SearchSvg} from '../assets/icons/search.svg'
import {ReactComponent as StarSvg} from "../assets/fonts/feather/star.svg"

import {ReactComponent as LightSvg} from '../assets/icons/lighticon.svg'
import {ReactComponent as DarkSvg} from '../assets/icons/darkicon.svg'
import HeaderLogout from "../components/HeaderLogout";
import {useDispatch, useSelector} from "react-redux";
import {userService} from "../services/UserService";
import {Link} from "react-router-dom";
import {toggleAside} from "../actions/main";
import {Dropdown} from "primereact/dropdown";
import {useEffect, useState} from "react";
import {setDepartment, setDepartments as setD} from "../actions/user";
import {AutoComplete} from "primereact/autocomplete";
import {sendRequest} from "../services/Sender";
import {isMobile, setSearchString as setSectionSearchStringAction} from "../actions/main";

export default function Header(props) {

    const userData = useSelector(function (state) {
        return state.auth.userData
    });

    const asideStatus = useSelector((state) => {
        return state.asideStatus
    })

    const dispatch = useDispatch()

    const [departments, setDepartments] = useState([]);
    const [currentDepartment, setCurrentDepartment] = useState(null)

    function updateDepartments(data) {
        setDepartments(data)
    }


    useEffect(() => {
        // if (departments.length === 0 && userData && userData.department.the_branche_manager) {
            let cleanupFunction = false;
            const fetchData = async () => {
                userService.GetAllDepartments().then(response => {
                    console.log(response.items)
                    dispatch(setD(response.items))
                    updateDepartments(response.items)
                })
            }

            fetchData();

            // функция очистки useEffect
            return () => cleanupFunction = true;
        // }
        if(departments.length === 0 && userData && userData.client_id){
            let cleanupFunction = false;
            dispatch(setD([userData.client_id]))
            updateDepartments([userData.client_id])
            // функция очистки useEffect
            return () => cleanupFunction = true;
        }
    }, [userData])

    function handleAsideToggle() {
        if (asideStatus !== 'close_icon')
            dispatch(toggleAside('close_icon'))
        else
            dispatch(toggleAside(''))
    }

    function handleDarkMode() {
        if (asideStatus !== 'dark-only') {
            dispatch(toggleAside('dark-only'))
            document.body.classList.add('dark-only');
        } else {
            dispatch(toggleAside(''))
            document.body.classList.remove('dark-only');
        }
    }

    useEffect(() => {
        if (departments && departments.length > 0) {
            departments.map(function (el) {
                // options.push({value: el.id, label: el.name})

                if (el.id === userService.GetCurrentDepartment()) {
                    setCurrentDepartment(el.id)
                }
            })
        }
    }, [departments])


    function handleDepartmentChange(e) {
        userService.SetCurrentDepartment(e.value)
        dispatch(setDepartment(e.value))
        setCurrentDepartment(e.value)
    }

    const departmentOptionTemplate = (option) => {
        return (
            <div className="d-flex align-items-center">
                {option.the_branche_manager ? <StarSvg className={'m-r-5'} style={{'width': '15px'}}/> : ''}
                <div>{option.label}</div>
            </div>
        );
    }

    // sendRequest('departments', 'GET', {
    //     'access-token': localStorage.getItem('user')
    // })

    const [searchString, setSearchString] = useState(null);
    const [filteredSearch, setFilteredSearch] = useState(null);

    const search = (event) => {
        if (!event.query.trim().length) {
            return;
        }
        sendRequest('search', 'GET', {
            'access-token': localStorage.getItem('user'),
            'string': event.query.trim()
        }).then((response) => {
            let _array = []
            if (response.children.length > 0) {
                let _children = {
                    label: 'Дети',
                    items: []
                };

                response.children.map((child) => {
                    _children.items.push({
                        name: child.fio,
                        icon: <img src={'http://yii2.easytickets.pro' + child.avatar} className={'m-r-10 btn-pill'}
                                   style={{'width': '30px'}}/>
                    })
                })

                _array.push(_children)
            }
            if (response.objects.length > 0) {
                let _objects = {
                    label: 'Заявки',
                    items: []
                };

                response.objects.map((object) => {
                    _objects.items.push({
                        name: '№' + object.id + ', '+object.name+', '+object.phone_code+object.phone+' '
                    })
                })

                _array.push(_objects)
            }
            setFilteredSearch(_array)
        })
    }


    return (
        <div className={"page-header " + asideStatus}>
            <div className="header-wrapper row m-0">
                <div className="header-logo-wrapper col-auto p-0">
                    <div className="logo-wrapper"><a href="/"><img className="img-fluid"
                                                                   src='/logo.svg'
                                                                   alt=""/></a></div>
                    <div className="toggle-sidebar">
                        <div className="status_toggle sidebar-toggle d-flex" onClick={handleAsideToggle}>
                            <LayoutSvg/>
                        </div>
                    </div>
                </div>
                <div className="left-side-header col ps-0 d-none d-md-block m-l-30">
                    {(userData && departments && currentDepartment) ?

                        <span className={"p-float-label"}>
                            <Dropdown filter={departments.length > 50} inputId={'dd-department'} options={departments.map((el) => {
                                return {value: el.id, label: el.name, the_branche_manager: el.the_branche_manager}
                            })} itemTemplate={departmentOptionTemplate} valueTemplate={(e) => <><i className="icon-home m-r-10"></i>{e.label}</>} onChange={handleDepartmentChange}
                                      className={'header-d-select'}
                                      value={currentDepartment}/>
                            {/*<label htmlFor="dd-department">Выберите филиал</label>*/}
                        </span>
                        : ''}
                </div>
                <div className="left-side-header col ps-0 d-none d-md-block">


                    <div className="">


                        {/*<input className="form-control" type="text" placeholder="Поиск клиентов" aria-label="search"*/}
                        {/*       aria-describedby="basic-addon1"/>*/}
                    </div>
                </div>
                <div className="nav-right col-10 col-sm-6 pull-right right-header p-0">
                    <ul className="nav-menus">

                        <li className="d-md-none resp-serch-input">
                            <div className="resp-serch-box">
                                <SearchSvg/>
                            </div>
                            <div className="form-group search-form">
                                <input type="text" placeholder="Поиск клиентов"/>
                            </div>
                        </li>
                        <li className="profile-nav onhover-dropdown pe-0 py-0 me-0">
                            <div className="media profile-media">
                                <ProfileLogo/>
                            </div>
                            {userData &&
                                <ul className="profile-dropdown onhover-show-div">



                                    <li>
                                        <HeaderLogout/>
                                    </li>
                                </ul>
                            }
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    )
}